import React, { PropTypes } from 'react';
import { Link } from 'react-router'
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

export default class ArchiveTemplateView extends React.Component {
  constructor(props) {
    super(props);
    // set state
    let template = this.toolTemplateData(SharedTools.cloneObject(props.template), props.templateContainerView);
    let templateContainerView =  template ? {width: props.templateContainerView.width, height: props.templateContainerView.width / template.width * template.height} : props.templateContainerView;
    
    let ratio = 1
    if (templateContainerView.width && template && template.width) {
      ratio = templateContainerView.width / template.width;
    }
    this.state = {
      templateContainerView: templateContainerView,
      template: template,
      fontRatio: props.template ? props.templateContainerView.width / props.template.width  * 0.3528 : 1,
      ratio
    };
    // bind this
    this._questionDetailView = this._questionDetailView.bind(this);
  }

  componentWillReceiveProps(newProps) {
    let template = this.toolTemplateData(SharedTools.cloneObject(newProps.template), newProps.templateContainerView);
    let templateContainerView =  template ? {width: newProps.templateContainerView.width, height: newProps.templateContainerView.width / template.width * template.height} : newProps.templateContainerView;
    let ratio = 1
    if (templateContainerView.width && template && template.width) {
      ratio = templateContainerView.width / template.width;
    }
    this.setState({
      template: template,
      templateContainerView: templateContainerView,
      fontRatio: newProps.template ? newProps.templateContainerView.width / newProps.template.width  * 0.3528 : 1,
    })
  }

  toolTemplateData (template, templateContainerView) {
    if (template) {
      let ratio = templateContainerView.width / template.width;
      template.areas.map((area) => {
        area.width = area.width * ratio;
        area.height = area.height * ratio;
        area.x = area.x * ratio;
        area.y = area.y * ratio;

        if (area.question_areas) {
          area.question_areas.map((question) => {
            question.width = question.width * ratio;
            question.height = question.height * ratio;
            question.x = question.x * ratio;
            question.y = question.y * ratio;
            question.questionToJson = JSON.parse(question.question);
            // question.type = this.toolQuestionType(question.type);
            if (question.type == "QuestionAreas::Filling") {
              question.questionToJson.titleArray = question.questionToJson.title.split('%%');
            }
            // 如果有答案
            if (question.answer) {
              question.hasAnswer = true;
            }
          })
        }
      })
    }

    return template
  }

  _questionDetailView(question) {
    let q = question.questionToJson, fontRatio = this.state.fontRatio;
    // for special template, if should_render == true, should not render any text/filling/choice question
    if (this.state.template.should_render == false && (question.type == "QuestionAreas::Filling" || question.type == "QuestionAreas::Text" || question.type == "QuestionAreas::Choice"))
      return null;

    switch (question.type) {

      case "QuestionAreas::Filling":
        return (
          <div className="question-box">{q.titleArray.map((text, index) =>
            <span key={index} style={{fontSize: q.font_size * fontRatio+'px', color: '#'+q.text_color}}>
              <span>{text}</span>
              <span className={"no-answer-box" + ((question.hasAnswer || index >= q.titleArray.length - 1) ? " hidden" : "")}></span>
              <span className={(!question.hasAnswer || index >= q.titleArray.length - 1) ? " hidden" : ""} style={{backgroundColor: '#'+q.highlight_background_color, color: '#'+q.highlight_text_color}}>{question.answer ? question.answer.answer[index] : ''}</span>
            </span>)}
          </div>
        )

      case "QuestionAreas::Text":
        return (
          <div className="question-box">
            <span style={{fontSize: q.font_size * fontRatio+'px', color: '#'+q.text_color, display: 'flex', justifyContent:(q.text_align?q.text_align:'left'), alignItems:(q.text_valign?q.text_valign:'center')}}>{question.hasAnswer ? question.answer.answer : q.title}</span>
          </div>
        )

      case "QuestionAreas::Image":
        return (
          <div className="question-box question-box-image" style={{zIndex: 0}}>
            {(question.hasAnswer || q.default_image) ? <img className="image" src={question.hasAnswer ? question.answer.url : q.default_image} style={{width: question.width, height: question.height}} /> : ''}
          </div>
        )

      case "QuestionAreas::Video":
        return (
          <div className="question-box question-box-image" style={{zIndex: 0}}>
            {(question.hasAnswer || q.default_image) ? <img className="image" src={question.hasAnswer ? question.answer.cover_image : q.default_image} style={{width: question.width, height: question.height}} /> : ''}
            {question.hasAnswer ? <div className="play-img" src="assets/template_play_icon.png" style={{width: question.width/15 + 'px', height: question.width/15 + 'px', backgroundSize: question.width/15 + 'px ' + question.width/15 + 'px'}}></div> : ''}
          </div>
        )

      case "QuestionAreas::Audio":
        return (
          <div className="question-box question-box-image">
            {(question.hasAnswer || q.default_image) ? <img className="image" src={question.hasAnswer ? q.play_image : q.default_image} style={{width: question.width, height: question.height}} /> : ''}
          </div>
        )

      case "QuestionAreas::Choice":
        return (
          <div className="question-box">
            {q.type == 'image' ? <img className="image" src={question.hasAnswer ? q.options.find((option) => option.sequence == question.answer.answer).selected_img : q.default_img} style={{width: question.width, height: question.height}} /> : ''}
          </div>
        )
    }
  }

  _questionView(question) {
    return (
      <div className="question-item" key={question.id} style={{width: question.width, height: question.height, left: question.x, top: question.y}}>
        {this._questionDetailView(question)}
      </div>
    )
  }


  render() {
    let { template, ratio } = this.state;
    let style = {
      width: this.state.templateContainerView.width,
      height: this.state.templateContainerView.height,
      margin: 3.5 * ratio
    }

    let imgStyle = {
      width: this.state.templateContainerView.width + 6 * ratio,
      height: this.state.templateContainerView.height + 6 * ratio,
      left: -3 * ratio,
      top: -3 * ratio
    }

    return (
      <div className="template-container" style={style}>
        {template ? <img src={template.bleed_url} style={imgStyle} className="background-image"/> : ''}
        {this.state.template && this.state.template.areas.map((area) =>
          <div key={area.id} className="area-item" style={{width: area.width, height: area.height, left: area.x, top: area.y}}
          >
            {area.question_areas.map((question) =>
              this._questionView(question)
            )}
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/ArchiveTemplateView.jsx